<template>
  <div>
    <!-- <v-img :src="ImageUrl || ''" max-height="300" /> -->
    <input
      type="file"
      ref="file"
      @change="onFileChange"
      accept="image/*"
      style="display: none"
    />

    <span
      style="overflow: hidden"
      class="file-upload__image__placeholder hover-pointer"
      :class="{ 'file-upload__image__placeholder--active': ImageUrl }"
      @click="showImagePreview"
      >{{ imageName ? imageName : $t("labels.upload_image") }}</span
    >
    <v-btn
      class="button button--upload"
      small
      text
      @click="$refs.file.click()"
      v-on="$attrs"
      :title="$t('labels.upload_image')"
    >
      <!-- <v-icon dark class="icon-upload"></v-icon> -->
      <span>
        <v-icon>mdi-cloud-upload</v-icon>
      </span>
    </v-btn>

    <!-- Image Preview -->
    <global-image-preview
      :showDialog="overlay"
      :imagePath="ImageUrl"
      @closePreview="overlay = false"
    />
    <!-- Image Preview -->

    <v-dialog v-model="errorDialog" max-width="300" persistent>
      <v-card>
        <v-card-text class="subheading">{{ ImageErrorMsg }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="resetData">{{ $t("button.got_it") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { isValidImgType, isValidImgSize } from "@/utils/validate";
import { UpdateMedia, StoreData } from "@/helpers/apiMethods";

export default {
  props: {
    file_name: {
      type: String,
      default: "",
    },
    reqType: {
      type: String,
      default: "",
    },
    maxSize: {
      type: Number,
      default: 1,
    },
    imgUrl: {
      type: String,
      default: null,
    },
    imgId: {
      default: null,
    },
    width: {
      type: Number,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
    maxHeight: {
      type: Number,
      default: 200,
    },
    minHeight: {
      type: Number,
      default: 200,
    },
    reset: {
      type: Boolean,
      default: false,
    },
    resetToggle: {
      type: Boolean,
      default: false,
    },
    fieldName: {
      type: String,
      default: "",
    },
    value: {
      type: String,
    },
    isPngImage: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    reset: {
      handler(value) {
        if (value) {
          console.log(value);
          this.resetImageFile();
        }
      },
      immediate: true,
    },
    // resetToggle: {
    //   handler() {
    //     this.resetImageFile();
    //   },
    //   immediate: true
    // },
    imgUrl: {
      handler(newValue) {
        if (newValue) {
          this.imageName = this.$t("labels.show_image");
          this.ImageUrl = newValue;
        }
      },
      immediate: true,
    },
  },
  computed: {
    ImageErrorMsg() {
      if (this.errorType === "MIME") {
        if (!this.isPngImage) {
          return this.$t("validation.imageType");
        } else {
          return this.$t("validation.isPngType");
        }
      } else if (this.errorType === "SIZE") {
        return this.$t("validation.imageSize", { count: this.maxSize });
      } else if (this.errorType === "DIMENSIONS") {
        return this.$t("validation.imageDimensions", {
          width: this.width,
          height: this.height,
        });
      } else if (this.errorType === "ratio") {
        return this.$t("validation.image_ratio");
      } else {
        return "";
      }
    },
  },
  data() {
    return {
      imageName: null,
      ImageUrl: null,
      errorDialog: null,
      errorText: "",
      errorType: "",
      //   imagePreview: "",
      absolute: false,
      overlay: false,
      zIndex: 990,
    };
  },
  methods: {
    onFileChange(e) {
      if (e.target.files.length > 0) {
        let imageFile = e.target.files[0];
        // with Dimensions
        if (this.width && this.height) {
          if (this.validateType(imageFile)) {
            this.validateDimentions(imageFile)
              .then(() => {
                this.readImage(imageFile);
              })
              .catch(() => {
                this.errorType = "DIMENSIONS";
                this.errorDialog = true;
              });
          }
          // without Dimensions
        } else {
          if (this.validateType(imageFile)) {
            this.readImage(imageFile);
            // this.validaRatio(imageFile)
            //   .then(() => {
            //   })
            //   .catch(() => {
            //     this.errorType = "ratio";
            //     this.errorDialog = true;
            //   });
          }
        }
      }
    },
    readImage(imageFile) {
      if (this.validateSize(imageFile)) {
        // console.log("image file", imageFile);
        this.imageName = imageFile.name;
        this.ImageUrl = URL.createObjectURL(imageFile);
        if (imageFile) {
          let dataObj = {
            file: imageFile,
          };
          if (this.fieldName) {
            dataObj.name = this.fieldName;
            this.$emit("fileSelected", dataObj);
          } else {
            this.$emit("fileSelected", dataObj);
          }
          if (this.imgId) {
            this.autoUpdate(dataObj.file);
          }
          // in case page-settings
          if (!this.imgId && this.reqType === "page-settings") {
            const formData = new FormData();
            formData.append(this.file_name, imageFile);
            formData.append("page_name", this.$route.name);
            formData.append("locale", this.locale);
            StoreData({ reqName: "page-settings", data: formData })
              .then((res) => {
                console.log(res);
              })

              .finally(() => {
                this.loading = false;
                this.imageName = null;
                this.resetData();
              });
          }
        }
      }
    },
    autoUpdate(image) {
      let formData = new FormData();
      formData.append("file", image);
      formData.append("_method", "PUT");
      formData.append("locale", "en");

      UpdateMedia({ param: this.imgId, data: formData })
        .then((res) => {
          const { media } = res.data;
          this.$emit("ImageUpdated", media);
          // this.imageName =""
        })
        .catch((err) => {
          console.log(err);
        });
    },
    validateDimentions(file) {
      return new Promise((resolve, reject) => {
        let image = new Image();
        image.src = URL.createObjectURL(file);
        image.addEventListener(
          "load",
          () => {
            let width = image.naturalWidth;
            let height = image.naturalHeight;
            if (width !== this.width && height !== this.height) {
              reject(false);
            } else {
              resolve(true);
            }
          },
          false
        );
      });
    },
    validaRatio(file) {
      return new Promise((resolve, reject) => {
        let image = new Image();
        image.src = URL.createObjectURL(file);
        image.addEventListener(
          "load",
          () => {
            let width = image.naturalWidth;
            let height = image.naturalHeight;
            if (width / height !== 1) {
              reject(false);
            } else {
              resolve(true);
            }
          },
          false
        );
      });
    },
    validateSize(file) {
      if (isValidImgSize(file.size, this.maxSize)) {
        return true;
      } else {
        this.errorType = "SIZE";
        this.errorDialog = true;
        return false;
      }
    },
    validateType(file) {
      if (isValidImgType(file, this.isPngImage)) {
        return true;
      } else {
        this.errorType = "MIME";
        this.errorDialog = true;
        return false;
      }
    },
    resetImageFile() {
      this.imageName = this.$t("labels.upload_image");
      this.ImageUrl = null;
      this.$refs.file.value = "";
    },
    resetData() {
      this.$refs.file.value = "";
      this.errorDialog = false;
      setTimeout(() => {
        this.errorType = "";
      }, 300);
    },
    showImagePreview() {
      if (this.ImageUrl) {
        this.overlay = true;
      }
    },
  },
};
</script>
